import axios from 'axios';
import { GRAPHQL_URI, API_SECRET } from '@config/environment';
export const BiometricApi = axios.create({
  baseURL: `${GRAPHQL_URI}/biometric`,
  headers: API_SECRET ? { secret: API_SECRET } : {},
});

export const UserApi = axios.create({
  baseURL: `${GRAPHQL_URI}/client/user`,
  headers: API_SECRET ? { secret: API_SECRET } : {},
});
